export const PHONE_DISPLAY = "0539 260 83 20";
export const PHONE_TEL = "tel:+905392608320";
export const WA_NUMBER = "905392608320";
export const INSTAGRAM_URL = "https://www.instagram.com/fxmotorsporlari/";
export const ADDRESS = "Ömerli, Mostar Sokak No:10/1, 34799 Çekmeköy/İstanbul";
export const MAP_URL = "https://share.google/R9GuagfzXLrOzvRSU";
export const MAP_EMBED = `https://www.google.com/maps?q=${encodeURIComponent("FX Motor Sporları, Mostar Sokak No:10/1, Ömerli, 34799 Çekmeköy/İstanbul")}&z=15&output=embed`;

export const waLink = (text) =>
  `https://wa.me/${WA_NUMBER}${text ? `?text=${encodeURIComponent(text)}` : ""}`;

export const WA_DEFAULT = waLink("Merhaba FX Motor Sporları, bilgi almak istiyorum.");

export const SERVICES = [
  { key: "enduro-tur", title: "Enduro Tur", text: "Motorun yoksa sorun değil. Profesyonel rehberler eşliğinde ormanda tur.", img: "/ig/ig25c.jpg", alt: "Orman manzaralı tepede üç enduro sürücüsü" },
  { key: "egitim", title: "Yetişkin Eğitim", text: "Enduro sürüşünü parkurda, adım adım öğren.", img: "/ig/ig20.jpg", alt: "Orman yolunda enduro sürücüsü" },
  { key: "cocuk-egitim", title: "Çocuk Eğitim", text: "Çocuklar için 5 derslik motosiklet eğitimi paketi.", img: "/ig/ig09.jpg", alt: "FX Motors finish garajı önünde motosiklet" },
];

export const TRAININGS = SERVICES.filter((s) => s.key !== "enduro-tur");

export const SERVICE_LABEL = Object.fromEntries(SERVICES.map((s) => [s.key, s.title]));

export const NAV = [
  { to: "/", label: "Ana Sayfa" },
  { to: "/egitimlerimiz", label: "Eğitimler", children: true },
  { to: "/enduro-tur", label: "Enduro Tur" },
  { to: "/uyelik", label: "Üyelik" },
  { to: "/galeri", label: "Galeri" },
  { to: "/hakkimizda", label: "Hakkımızda" },
  { to: "/iletisim", label: "İletişim" },
];

export const serviceHref = (key) => (key === "enduro-tur" ? "/enduro-tur" : `/egitimler/${key}`);
export const bookingHref = (key) => (key ? `/rezervasyon?hizmet=${key}` : "/rezervasyon");
